class EventBus {
  constructor () {
    this.events = []
  }

  findEvent (type) {
    for (let i = 0; i < this.events.length; i++) {
      const event = this.events[i]
      if (event.type === type) return event
    }
    return false
  }

  on (type, callback) {
    const event = this.findEvent(type)
    if (event) {
      event.callbacks.push(callback)
    } else {
      this.events.push({
        type,
        callbacks: [callback]
      })
    }
  }

  off (type, callbackToRemove) {
    const event = this.findEvent(type)
    if (event) {
      event.callbacks = event.callbacks.filter(callback => callback !== callbackToRemove)
    }
  }

  emit (type, payload) {
    const event = this.findEvent(type)
    if (event) {
      event.callbacks.forEach(callback => callback(payload))
    }
  }

  reset () {
    this.events = []
  }
}

export const DataBus = new EventBus()
export const UIBus = new EventBus()
